export default __webpack_public_path__ + "static/media/AnimalPage4.2f17f34e.txt";